import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TopActionBar from "./TopActionBar";
import { SocketState } from "../context/SocketProvider";
import { SHOW_MAIN_ERROR_MODAL } from "../redux/errorMessageSlice";

const LayoutReportUser = () => {
    const dispatch = useDispatch();
    const { socket } = SocketState();

    const [list, setList] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [amount, setAmount] = useState("");

    const formatForInput = (date) => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    // Initialize state
    const [fromDate, setFromDate] = useState(formatForInput(new Date()));
    const [toDate, setToDate] = useState(formatForInput(new Date()));


    const [totals, setTotals] = useState({
        sale: 0,
        win: 0,
        cancel: 0,
        balance: 0,
        commission: 0,
        net: 0,
    });

    /* ================= DATE HELPERS ================= */
    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}-${String(
            d.getMonth() + 1
        ).padStart(2, "0")}-${d.getFullYear()}`;
    };


    const getToday = () => {
        const d = new Date();
        return `${String(d.getDate()).padStart(2, "0")}-${String(
            d.getMonth() + 1
        ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    /* ================= FETCH REPORT ================= */
    const fetchReport = () => {
        if (!socket) return;

        const start = formatDate(fromDate);
        const end = formatDate(toDate);

        const today = formatDate(new Date());
        const isFilter = !(start === today && end === today);


        console.log({
            en: "USER_REPORT_LISTS",
            data: {
                is_filter: isFilter,
                start_date: start,
                end_date: end,
            },
        })
        socket.emit("req", {
            en: "USER_REPORT_LISTS",
            data: {
                is_filter: isFilter,
                start_date: start,
                end_date: end,
            },
        });
    };

    /* ================= INITIAL LOAD ================= */
    useEffect(() => {
        fetchReport();
    }, [socket]);

    /* ================= SOCKET RESPONSE ================= */
    useEffect(() => {
        if (!socket) return;

        const handler = (res) => {
            switch (res.en) {
                case "USER_REPORT_LISTS":
                    if (!res.err) {
                        const rows = res.data?.list || [];
                        setList(rows);

                        let t = {
                            sale: 0,
                            win: 0,
                            cancel: 0,
                            balance: 0,
                            commission: 0,
                            net: 0,
                        };

                        rows.forEach((r) => {
                            t.sale += Number(r.play_amount || 0);
                            t.win += Number(r.win_amount || 0);
                            t.cancel += Number(r.unclaim_amount || 0);
                            t.balance += Number(r.end_amount || 0);
                            t.commission += Number(r.commission_amount || 0);
                            t.net += Number(r.ntp_amount || 0);
                        });

                        setTotals(t);
                    } else {
                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));
                    }
                    break;

                default:
                    break;
            }
        };

        socket.on("res", handler);
        return () => socket.off("res", handler);
    }, [socket, fromDate, toDate]);


    return (
        <>
            <TopActionBar />

            {/* ===== FILTER BAR ===== */}
            <div className="filter-bar">
                <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    style={{ backgroundColor: "#f3efe6" }}
                />
                <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    style={{ backgroundColor: "#f3efe6" }}
                />
                <button className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg" onClick={fetchReport}>Search</button>
            </div>

            {/* ===== TABLE ===== */}
            <div className="table-wrapper">
                <table className="report-table">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Sale</th>
                            <th>Win</th>
                            <th>Unclaim</th>
                            <th>Balance</th>
                            <th>Commission</th>
                            <th>Net</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((r, i) => (
                            <tr key={i}>
                                <td>{r.user_name}</td>
                                <td>{r.play_amount.toFixed(2)}</td>
                                <td>{r.win_amount.toFixed(2)}</td>
                                <td>{r.unclaim_amount.toFixed(2)}</td>
                                <td>{r.end_amount.toFixed(2)}</td>
                                <td>{r.commission_amount.toFixed(2)}</td>
                                <td>{r.end_amount.toFixed(2)-r.commission_amount.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>

                    <tfoot>
                        <tr>
                            <td>TOTAL</td>
                            <td>{totals.sale.toFixed(2)}</td>
                            <td>{totals.win.toFixed(2)}</td>
                            <td>{totals.cancel.toFixed(2)}</td>
                            <td>{totals.balance.toFixed(2)}</td>
                            <td>{totals.commission.toFixed(2)}</td>
                            <td>{totals.balance.toFixed(2)-totals.commission.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* ===== STYLES ===== */}
            <style>{`

        .filter-bar,
        .wallet-box {
          display: flex;
          gap: 8px;
          padding: 10px;
          flex-wrap: wrap;
        }

        input, select, button {
          padding: 6px 10px;
          font-size: 13px;
        }

        .add {
          background: green;
          color: #fff;
          border: none;
        }

        .deduct {
          background: red;
          color: #fff;
          border: none;
        }

        .report-table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #ccc;
          padding: 6px;
          text-align: center;
          font-size: 13px;
        }

        th, tfoot td {
          background: #9acd32;
          color: #fff;
        }
      `}</style>
        </>
    );
};

export default LayoutReportUser;
